import { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';

import { GENERAL_ERROR_MESSAGE } from 'constants/texts';
import { useSnackbar } from 'hooks/useSnackbar';
import axios from 'utils/axios';

export function useVerify() {
  const [email] = useQueryParam('email', StringParam);
  // @ts-ignore
  const { title, guestPortalId: accessToken } = useParams();
  const onSnackbar = useSnackbar();
  const isCustomDomain = location.pathname.includes('/gp/');
  const rootPath = isCustomDomain ? `${location.origin}/gp` : location.origin;
  const redirectUri = [rootPath, title, accessToken].join('/');

  const verifyMutation = useMutation({
    mutationFn: () => axios.post<{ success: string }>('auth/verify-account-resend', { email, redirectUri }),
    onError: (e: { error?: string }) => {
      onSnackbar(e.error || GENERAL_ERROR_MESSAGE, true);
    },
    onSuccess: () => onSnackbar('Email has been sent'),
  });

  useEffect(() => {
    verifyMutation.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    verifyMutation,
  };
}
